import toast from "./toast.vue"

const Toast = {
  install(Vue) {
    Vue.component("toast", toast)
    Vue.prototype.$toast = async function(payload) {
      try {
        const promise = await _$.progress.create()
        const { element, content, confirmButton, cancelButton, theme, timeout } = payload
        const $package = {
          element,
          content,
          confirmButton,
          cancelButton,
          theme,
          timeout,
          resolve: e => {
            promise.resolve(e)
          },
          reject: e => {
            promise.reject(e)
          }
        }

        _$.vue.$emit("toast", $package)

        return promise.done
      } catch (err) {
        return _$.error(err)
      }
    }
  }
}

export default Toast
